export { default as ResignationSlot } from './ResignationSlot';
